<script setup lang="ts">
import { onMounted, provide, ref } from 'vue'

import ClosingSection from './components/ClosingSection.vue'
import SiteHeader from './components/SiteHeader.vue'
import CareerPortal from './components/sections/CareerPortal.vue'
import GrowthGalaxy from './components/sections/GrowthGalaxy.vue'
import LifecycleSection from './components/sections/LifecycleSection.vue'
import ProjectsSection from './components/sections/ProjectsSection.vue'
import SeriesSection from './components/sections/SeriesSection.vue'
import HeroSection from './components/hero/HeroSection.vue'
import { useExperience } from './composables/useExperience'
import { pointerMotionKey, usePointerMotion } from './composables/usePointerMotion'
import { useSiteMotion } from './composables/useSiteMotion'

const shell = ref<HTMLElement | null>(null)
const experience = useExperience()
const pointerMotion = usePointerMotion(shell, experience.prefersReducedMotion)

useSiteMotion(shell, experience.prefersReducedMotion)
provide(pointerMotionKey, pointerMotion)

onMounted(() => experience.scheduleIntro())
</script>

<template>
  <div
    ref="shell"
    class="site-shell"
    :data-quality="experience.quality.value"
    :class="{ 'intro-active': !experience.introComplete.value }"
  >
    <a class="skip-link" href="#main-content">跳到主要内容</a>
    <div class="pointer-halo" aria-hidden="true"><i /></div>
    <div class="site-progress" aria-hidden="true"><span class="site-progress__bar" /></div>
    <SiteHeader
      :quality="experience.quality.value"
      :preference="experience.preference.value"
      @cycle-quality="experience.cycleQuality"
    />
    <main id="main-content">
      <HeroSection
        :quality="experience.quality.value"
        :intro-mode="experience.introMode.value"
        :intro-complete="experience.introComplete.value"
        :reduced-motion="experience.prefersReducedMotion.value"
        @skip="experience.finishIntro"
      />
      <LifecycleSection :reduced-motion="experience.prefersReducedMotion.value" />
      <GrowthGalaxy />
      <CareerPortal />
      <ProjectsSection />
      <SeriesSection />
      <ClosingSection />
    </main>
  </div>
</template>
